/*
  Function is used for right Type Inference in filter expressions
  [null, 'text'].filter(excludeFalsy) will be string[] type,
  [null, 'text'].filter(Boolean) will be (string | null)[] which is incorrect
 */
export function excludeFalsy<T>(value: T): value is Exclude<T, false | null | undefined | '' | 0> {
  return Boolean(value)
}
